import React from 'react'
import { useTranslation } from 'react-i18next'
import { Callout, Combobox, ComboboxGroupProps, ComboboxProps } from '@node-space/ui-components'
import { useCustomersDropdown } from './useCustomersDropdown'

type CustomersDropdownProps = ComboboxProps | ComboboxGroupProps

export const CustomersDropdown = (props: CustomersDropdownProps) => {
  const { t } = useTranslation()
  const { isFetching, customerOptions, setQuery, onChangeCustomer, isEmpty } = useCustomersDropdown(
    props.onChange
  )

  return (
    <>
      {isEmpty ? (
        <Callout variant="warning">{t('noCustomers')}</Callout>
      ) : (
        <Combobox
          {...props}
          testId="customer"
          onChange={onChangeCustomer}
          items={customerOptions}
          loading={isFetching}
          loadingInline={isFetching}
          onInputChange={setQuery}
          modal
        />
      )}
    </>
  )
}
